import React from "react";
import PropTypes from "prop-types";
// Material imports
import Grid from "@mui/material/Grid";
import { useTheme } from "@mui/material/styles";
// Limitless imports
import Typography from "@limitless/modern/data-display/typography/Typography";

const IN_PROGRESS = "in_progress";
const INVITED = "invited";
const WAITING = "waiting";

const getMap = theme => ({
    [IN_PROGRESS]: {
        label: "Your Progress",
        color: theme.palette.primary.info
    },
    [INVITED]: {
        label: "in review",
        color: theme.palette.primary.main
    },
    [WAITING]: {
        label: "",
        color: null
    }
});

const ExpertOnboardingSummaryState = ({ onboardingOutcomeState, membershipState, ctaType }) => {
    const isInvited = onboardingOutcomeState.includes(IN_PROGRESS) && membershipState === "invited";
    let derivedState;

    if (ctaType === WAITING) {
        derivedState = WAITING;
    } else if (isInvited) {
        derivedState = INVITED;
    } else {
        derivedState = IN_PROGRESS;
    }

    const theme = useTheme();

    const labelMap = getMap(theme);
    const stateLabel = labelMap[derivedState];

    return (
        <Grid item xs={9} mt={1}>
            <Typography style={{ color: stateLabel.color, fontSize: "14px" }} variant="subtitle2">
                {stateLabel.label}
            </Typography>
        </Grid>
    );
};

export default ExpertOnboardingSummaryState;

ExpertOnboardingSummaryState.propTypes = {
    onboardingOutcomeState: PropTypes.string.isRequired,
    membershipState: PropTypes.string.isRequired,
    groupName: PropTypes.string.isRequired,
    ctaType: PropTypes.string
};
